<template>
  <form class="tile filters filter-form">
    <div class="flex__between heading--box">
      <span class="heading">Filters</span>
      <button class="btn btn__small" @click.prevent="resetFilters">Reset Filters</button>
    </div>
    <label class="filter-form--label" for="name">
      Requester Name:
      <input
        type="text"
        v-model="form.name"
        id="name"
        @keypress.prevent.enter="submitFilters"
      />
    </label>
    <label class="filter-form--label" for="status">
      Request Status:
      <select id="status" name="status" v-model="form.status">
        <option value="all">All</option>
        <option value="untouched">Untouched</option>
        <option value="unfinished">Unfinished</option>
        <option value="finished">Finished</option>
      </select>
    </label>
    <label class="filter-form--label" for="service-status">
      Incomplete Services:
      <select
        id="service-status"
        name="service-status"
        v-model="form.incompleteServices"
      >
        <option value="any">Any</option>
        <option
          v-for="service in getServices"
          :key="service"
          :value="service"
        >{{ service }}</option>
      </select>
    </label>
    <label class="filter-form--label" for="sort">
      Sort Requests:
      <select id="sort" name="sort" v-model="form.sort">
        <option value="newest-to-oldest">Newest-to-Oldest</option>
        <option value="oldest-to-newest">Oldest-to-Newest</option>
      </select>
    </label>
    <label class="filter-form--label" for="date-min">
      Submitted Range (min max):
      <div class="date--grid">
        <input
          type="date"
          v-model="form.dateMin"
          id="date-min"
          placeholder="YYYY-MM-DD"
          @keypress.prevent.enter="submitFilters"
          v-mask="'####-##-##'"
        />
        <input
          type="date"
          v-model="form.dateMax"
          id="date-max"
          placeholder="YYYY-MM-DD"
          @keypress.prevent.enter="submitFilters"
          v-mask="'####-##-##'"
        />
      </div>
    </label>
    <button class="btn btn--submit" @click.prevent="submitFilters">Apply Filters</button>
  </form>
</template>

<script>
import moment from "moment";

export default {
  props: ["namespace", "filters"],
  data() {
    return {
      form: {
        name: this.filters.name,
        status: this.filters.status,
        incompleteServices: this.filters.incompleteServices,
        sort: this.filters.sort,
        dateMin: this.filters.dateMin,
        dateMax: this.filters.dateMax
      }
    };
  },
  computed: {
    getServices() {
      return this.$store.getters[`${this.namespace}/getServices`];
    }
  },
  methods: {
    startSetFilters(form) {
      this.$store.dispatch(`${this.namespace}/startSetFilters`, form);
    },
    resetFilters() {
      this.form.name = "";
      this.form.status = "all";
      this.form.incompleteServices = "any";
      this.form.sort = "newest-to-oldest";
      this.form.dateMin = null;
      this.form.dateMax = null;
      this.startSetFilters(this.form);
    },
    submitFilters() {
      const cleanForm = { ...this.form };
      if (this.form.dateMin) {
        cleanForm.dateMin = moment(`${cleanForm.dateMin} 12:00:00 am`, [
          "YYYY-MM-DD hh:mm:ss a"
        ]).format("MM-DD-YYYY hh:mm:ss a");
      }
      if (this.form.dateMax) {
        cleanForm.dateMax = moment(`${cleanForm.dateMax} 12:00:00 pm`, [
          "YYYY-MM-DD hh:mm:ss a"
        ]).format("MM-DD-YYYY hh:mm:ss a");
      }
      this.startSetFilters(cleanForm);
    }
  }
};
</script>

<style scoped lang="scss">
</style>